/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPostedWire.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/posted-wire";

export class AutogenModelPostedWire<RowType extends ModelRow> extends Endpoint<RowType, RowPostedWireFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPostedWire extends ModelRow<RowPostedWireFields> {
	constructor(values?: Partial<RowPostedWireFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPostedWireFields {
	charge_amt: number;
	charge_amt_c: string;
	charge_amt_d: Date;
	charge_amt_n: number;
	charge_amt_r: number;
	charge_code_id: string;
	check_amount: number;
	check_amount_c: string;
	check_amount_d: Date;
	check_amount_n: number;
	check_amount_r: number;
	check_code: string;
	check_number: string;
	company_id: string;
	deduct_code_id: string;
	deduct_flag: string;
	descr: string;
	driver_fee_amt: number;
	driver_fee_amt_c: string;
	driver_fee_amt_d: Date;
	driver_fee_amt_n: number;
	driver_fee_amt_r: number;
	driver_id: string;
	fuel_card_id: string;
	fuel_interface_id: string;
	id: string;
	ifuel_quikq_asset_id: string;
	manifest_id: string;
	movement_id: string;
	order_id: string;
	payee_id: string;
	payee_name: string;
	post_key: string;
	post_module: string;
	service_charge: number;
	service_charge_c: string;
	service_charge_d: Date;
	service_charge_n: number;
	service_charge_r: number;
	subaccount_id: string;
	trans_date_time: Date;
	user_id: string;
	void_date: Date;
	voidflag: string;
	wire_contract_tch: number;
	"wirecode.allow_aft_xfer_settlement": string;
	"wirecode.ap_glid": string;
	"wirecode.carrier_limit_amount": number;
	"wirecode.carrier_limit_amount_c": string;
	"wirecode.carrier_limit_amount_d": Date;
	"wirecode.carrier_limit_amount_n": number;
	"wirecode.carrier_limit_amount_r": number;
	"wirecode.carrier_limit_method": string;
	"wirecode.carrier_order_pct_limit": number;
	"wirecode.carrier_valid_move_status": string;
	"wirecode.charge_code_id": string;
	"wirecode.company_id": string;
	"wirecode.company_limit_amount": number;
	"wirecode.company_limit_amount_c": string;
	"wirecode.company_limit_amount_d": Date;
	"wirecode.company_limit_amount_n": number;
	"wirecode.company_limit_amount_r": number;
	"wirecode.company_limit_method": string;
	"wirecode.company_order_pct_limit": number;
	"wirecode.company_valid_move_status": string;
	"wirecode.contract_carrier": number;
	"wirecode.contract_driver": number;
	"wirecode.contract_no_payee": number;
	"wirecode.contract_ownerop": number;
	"wirecode.create_deduction": string;
	"wirecode.create_other_charge": string;
	"wirecode.deduct_code_id": string;
	"wirecode.deduct_in_provider_currency": string;
	"wirecode.deduct_status": string;
	"wirecode.descr": string;
	"wirecode.driver_fee_amt": number;
	"wirecode.driver_fee_amt_c": string;
	"wirecode.driver_fee_amt_d": Date;
	"wirecode.driver_fee_amt_n": number;
	"wirecode.driver_fee_amt_r": number;
	"wirecode.expense_glid": string;
	"wirecode.fuel_interface_id": string;
	"wirecode.id": string;
	"wirecode.include_fee_exp": string;
	"wirecode.is_active": string;
	"wirecode.is_atm_cash": string;
	"wirecode.issuing_user_group": string;
	"wirecode.issuing_users": string;
	"wirecode.msts_addl_fee_percent": number;
	"wirecode.msts_addl_fee_threshold": number;
	"wirecode.msts_addl_fee_threshold_c": string;
	"wirecode.msts_addl_fee_threshold_d": Date;
	"wirecode.msts_addl_fee_threshold_n": number;
	"wirecode.msts_addl_fee_threshold_r": number;
	"wirecode.no_validation": string;
	"wirecode.ownerop_limit_amount": number;
	"wirecode.ownerop_limit_amount_c": string;
	"wirecode.ownerop_limit_amount_d": Date;
	"wirecode.ownerop_limit_amount_n": number;
	"wirecode.ownerop_limit_amount_r": number;
	"wirecode.ownerop_limit_method": string;
	"wirecode.ownerop_order_pct_limit": number;
	"wirecode.ownerop_valid_move_status": string;
	"wirecode.plus_minus": string;
	"wirecode.require_order": string;
	"wirecode.service_charge": number;
	"wirecode.service_charge_c": string;
	"wirecode.service_charge_d": Date;
	"wirecode.service_charge_n": number;
	"wirecode.service_charge_r": number;
	"wirecode.subaccount_carrier": string;
	"wirecode.subaccount_driver": string;
	"wirecode.subaccount_no_payee": string;
	"wirecode.subaccount_ownerop": string;
	"wirecode.unposted_wire_status": string;
	"wirecode.wire_type": string;
	wirecode_id: string;
}

